import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';
import { SESSION_KEY_USER_ORDERS_DATA } from '../../constants';

interface EventItem {
    id: number;
}

interface OrderItem {
    id: number;
    item: {
        event: EventItem;
    };
}

interface Child {
    id: number;
    orderItems: OrderItem[];
}

interface UserOrderResponse {
    id: number;
    email: string;
    children: Child[];
}

interface ChildrenEventsMap {
    [key: number]: number[];
}

const getUser = async () => {
    let arrayResponse = {
        success: false,
        message: 'Failed to get user.',
    };

    try {
        const response = await eventsRequest<UserOrderResponse>('/users', 'get');

        if (response.status === 200 || response.status === 201) {
            const childrenEventsMap = response.data.children.reduce<ChildrenEventsMap>((acc, child) => {
                const eventIds = new Set(child.orderItems.map(orderItem => orderItem.item.event.id));
                acc[child.id] = Array.from(eventIds);
                return acc;
            }, {});

            arrayResponse.success = true;
            arrayResponse.message = 'Get user successful.';
            localStorage.setItem(SESSION_KEY_USER_ORDERS_DATA, JSON.stringify(childrenEventsMap));
        }
        
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
};

export default getUser;
